import { MultiString } from "../../../../../i18n/MultiString";
import { DataType } from "../../../../evaluators/DataType";
import { EvaluationResult } from "../../../../evaluators/EvaluationResult";
import { Evaluator } from "../../../../evaluators/Evaluator";
import { BinaryExpression } from "../../../../expressions/BinaryExpression";
import { RJParserMessages } from "../../../RJParserMessages";
import { DataTypes } from "../DataTypes";
import { BinaryFunction } from "./BinaryFunction";

export class Multiply extends BinaryFunction
{
  _process():EvaluationResult<any>
  { 
    if ( this.typesAre( DataTypes.Number ) )
    {
      return EvaluationResult.withValue( this.leftNumber * this.rightNumber, DataTypes.Number );
    }
    else if ( this.typesAre( DataTypes.Vector3 ) )
    {
      let result = this.leftVector3.clone().multiply( this.rightVector3 );

      return EvaluationResult.withValue( result, DataTypes.Vector3 );
    }
    else if ( this.typesAre( DataTypes.Number, DataTypes.Vector3 ) )
    {
      let result = this.rightVector3.clone().multiplyScalar( this.leftNumber );
      return EvaluationResult.withValue( result, DataTypes.Vector3 );
    }
    else if ( this.typesAre( DataTypes.Vector3, DataTypes.Number ) )
    {
      let result = this.leftVector3.clone().multiplyScalar( this.rightNumber );
      return EvaluationResult.withValue( result, DataTypes.Vector3 );
    }

    return EvaluationResult.asError( this.binaryExpression, MultiString.resolve( RJParserMessages.parametersNotFitting ) +  " : Multiply(*) "  );
  }
}